export default "__VITE_ASSET__Bnz4HWud__"